import { Skeleton } from '@cocoonspace/ui/components/skeleton'

import {
	ScheduleCard,
	ScheduleCardActions,
	ScheduleCardDescription,
	ScheduleCardHeader,
	ScheduleCardTitle,
} from '../../scheduling-card'

export const EventTypeCardSkeleton = () => (
	<ScheduleCard>
		<ScheduleCardHeader>
			<ScheduleCardTitle className='flex items-center gap-4'>
				<Skeleton className='h-4 w-[150px]' />
			</ScheduleCardTitle>

			<ScheduleCardActions>
				<Skeleton className='size-[24px] rounded-full' />
				<Skeleton className='size-[24px] rounded-full' />
				<Skeleton className='size-[24px] rounded-full' />
				<Skeleton className='h-[24px] w-[42px] rounded-full' />
			</ScheduleCardActions>
		</ScheduleCardHeader>

		<ScheduleCardDescription className='flex flex-col gap-4'>
			<Skeleton className='h-3 w-[250px]' />
			<Skeleton className='h-3 w-[350px]' />
			<Skeleton className='h-[20px] w-[72px]' />
		</ScheduleCardDescription>
	</ScheduleCard>
)

export const EventTypeCardSkeletonList = () => (
	<div className='flex flex-col gap-4'>
		{Array.from({ length: 10 }, (_, i) => (
			<EventTypeCardSkeleton key={i} />
		))}
	</div>
)
